module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-table noselect h-100"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tbody"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.absencesDemandeTerminee), function(absence) {
    return _c('div', {
      staticClass: "tr",
      attrs: {
        "data-testid": _vm.getAbsenceRequestEntryDataTestID(absence, '')
      }
    }, [_c('div', {
      staticClass: "td cln-type"
    }, [_c('div', {
      staticClass: "badges",
      attrs: {
        "title": absence.LibelleTypeAbsence
      }
    }, [(absence.CodeTypeAbsence == 'JCONG') ? _c('div', {
      staticClass: "badge mr-2 text-center",
      style: ({
        background: absence.Couleur
      })
    }, [_vm._v("CP")]) : (absence.CodeTypeAbsence == 'JRECU') ? _c('div', {
      staticClass: "badge mr-2 text-center",
      style: ({
        background: absence.Couleur
      })
    }, [_vm._v("RTT")]) : (absence.CodeTypeAbsence == 'HCSS') ? _c('div', {
      staticClass: "badge mr-2 text-center",
      style: ({
        background: absence.Couleur
      })
    }, [_vm._v("HSS")]) : (absence.CodeTypeAbsence == 'JTELE') ? _c('div', {
      staticClass: "badge mr-2 text-center",
      style: ({
        background: absence.Couleur
      })
    }, [_vm._v("TL")]) : _c('div', {
      staticClass: "badge mr-2 text-center",
      style: ({
        background: absence.Couleur != null ? absence.Couleur : _vm.grey
      })
    }, [_vm._v(_vm._s(absence.CodeTypeAbsence))])]), _vm._v(" "), _c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(absence.LibelleTypeAbsence))])]), _vm._v(" "), _c('div', {
      staticClass: "td cln-debut text-center"
    }, [_c('span', {
      staticClass: "fas fa-sign-out-alt mr-1 hide-mini",
      staticStyle: {
        "color": "#2ecc71"
      }
    }), _vm._v("\n                    " + _vm._s(_vm._f("moment")(absence.DateDebut, "DD/MM/YY")) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-fin text-center"
    }, [_c('span', {
      staticClass: "fas fa-sign-in-alt mr-1 hide-mini",
      staticStyle: {
        "color": "#ff7675"
      }
    }), _vm._v("\n                    " + _vm._s(_vm._f("moment")(absence.DateFin, "DD/MM/YY")) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-duree"
    }, [_c('span', {
      staticClass: "far fa-clock mr-1 hide-mini"
    }), _vm._v(" "), (absence.NombreJours > 0) ? _c('span', {
      attrs: {
        "title": absence.NombreJours + ' jour(s)'
      }
    }, [_vm._v("\n                        " + _vm._s(absence.NombreJours) + " jour(s)\n                    ")]) : (absence.NombreHeures > 0) ? _c('span', {
      attrs: {
        "title": absence.NombreHeures + ' heure(s)'
      }
    }, [_vm._v("\n                        " + _vm._s(absence.NombreHeures) + " heure(s)\n                    ")]) : (absence.NombreMois > 0) ? _c('span', {
      attrs: {
        "title": absence.NombreMois + ' mois'
      }
    }, [_vm._v("\n                        " + _vm._s(absence.NombreMois) + " mois\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "td cln-etat cln-center"
    }, [(_vm.estValideOuPlus(absence)) ? _c('span', {
      staticClass: "circle circle-green",
      attrs: {
        "title": _vm.getLibelleEtat(absence)
      }
    }) : (_vm.estRefuse(absence)) ? _c('span', {
      staticClass: "circle circle-red",
      attrs: {
        "title": _vm.getLibelleEtat(absence)
      }
    }) : _c('span', {
      staticClass: "circle circle-grey",
      attrs: {
        "title": _vm.getLibelleEtat(absence)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "td cln-commentaire cln-center"
    }, [(_vm.estCommentaireAccessible(absence)) ? _c('button', {
      staticClass: "inp-button-outline blue",
      attrs: {
        "title": "Commentaire"
      },
      on: {
        "click": function($event) {
          _vm.afficherModalDetailAbsence(absence)
        }
      }
    }, [_c('span', {
      staticClass: "icon fas fa-fw fa-comment-dots"
    })]) : _c('button', {
      staticClass: "inp-button-outline blue",
      attrs: {
        "title": "Aucun commentaire",
        "disabled": ""
      }
    }, [_c('span', {
      staticClass: "icon fas fa-fw fa-comment-dots"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "td cln-annulation cln-center"
    }, [(_vm.estAnnulable(absence)) ? _c('button', {
      staticClass: "inp-button-outline red",
      attrs: {
        "title": "Annuler la demande",
        "data-testid": _vm.getAbsenceRequestEntryDataTestID(absence, '-cancel-button')
      },
      on: {
        "click": function($event) {
          _vm.demanderAnnulationAbsenceSalarie(absence)
        }
      }
    }, [_c('span', {
      staticClass: "icon fas fa-fw fa-times"
    })]) : _c('button', {
      staticClass: "inp-button-outline red",
      attrs: {
        "title": "Impossible d'annuler la demande",
        "disabled": ""
      }
    }, [_c('span', {
      staticClass: "icon fas fa-fw fa-times"
    })])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thead"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th cln-type nohover",
    attrs: {
      "title": "Type"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Type")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-debut nohover",
    attrs: {
      "title": "Début"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Début")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-fin nohover",
    attrs: {
      "title": "Fin"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Fin")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-duree nohover",
    attrs: {
      "title": "Durée"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Durée")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-etat nohover",
    attrs: {
      "title": "État"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("État")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-commentaire nohover",
    attrs: {
      "title": "Commentaire"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Commentaire")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-annulation nohover",
    attrs: {
      "title": "Annulation"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Annulation")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "section cln-type"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-debut"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-fin"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-duree"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-etat"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-commentaire"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-annulation"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-528d0dc5"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsences/listeDesDemandes/espaceSalarie/tableaux/tableauDemandeTerminee/tableauDemandeTerminee.vue.html
// module id = 0aax
// module chunks = 2